import React, { useEffect } from "react";
import { Observer, useLocalStore } from "mobx-react";
import { ModalStore } from "./ModalStore";
import { ModalContext } from "./hooks";

interface ModalStoreProviderProps {}

export const ModalStoreProvider: React.FC<ModalStoreProviderProps> = React.memo((props) => {
  const modalStore = useLocalStore(() => new ModalStore());

  useEffect(() => {
    return () => {
      modalStore.dispose();
    };
  }, []);

  return (
    <ModalContext.Provider value={modalStore}>
      {props.children}
      <Observer>
        {/* @ts-ignore */}
        {() => {
          return modalStore.needToRenderChildrenIds.map((id) => {
            const Component = modalStore.modalsMapping.get(id);
            const props = modalStore.modalPropsMapping.get(id);

            return <Component {...props} key={id} />;
          });
        }}
      </Observer>
    </ModalContext.Provider>
  );
});

export default React.memo(ModalStoreProvider);
